import { getActiveAccessToken } from '@/features/impersonation-session';

export const fetchMediaUrl = async (url: string): Promise<string | null> => {
  if (!isApiUrl(url)) {
    return url;
  }

  try {
    const accessToken = await getActiveAccessToken();

    const headers: HeadersInit = {};
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const response = await fetch(url, { headers });

    if (!response.ok) {
      throw new Error(`Failed to fetch media URL: ${response.status} ${response.statusText}`);
    }

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const data = await response.json();
      return data.data?.url || null;
    }

    // Direct image/binary response — create a blob URL
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Failed to fetch media URL:', error);
    return null;
  }
};

export const isApiUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return (
      urlObj.hostname.includes('withallo.com') || urlObj.hostname.includes('api-dev.withallo.com')
    );
  } catch {
    return false;
  }
};
